import { getPercentChangeBetweenTwoNumbers } from '@/utils/mathHelper';
import { GridAggregationFunction } from '@mui/x-data-grid-premium';

/**
 * Unrealized - % Change (Percentage Change)
 *
 * Copy Legacy Behavior:
 * https://wealthaccess.atlassian.net/browse/EUD-419
 * https://github.com/Wealth-Access/legacy-ui/blob/main/Scripts/src/Investor/Components/GainsAndLosses/UnrealizedGainsGrid.jsx
 *
 * Note: This returns a percentage but does not include formatting.
 * The formatting is handled by the column's `valueFormatter` method.
 *
 * https://mui.com/x/react-data-grid/aggregation/#creating-custom-functions
 */
export const unrealizedPercentChangeAggregation: GridAggregationFunction<
  {
    costBasis: number;
    currentBalance: number;
  },
  number
> = {
  getCellValue: ({ row }) => {
    return {
      costBasis: row.CostBasis,
      currentBalance: row.CurrentBalance,
    };
  },
  apply: ({ values }) => {
    let summedCostBasis = 0;
    let summedCurrentBalance = 0;

    values.forEach((value) => {
      if (value) {
        summedCostBasis += value.costBasis;
        summedCurrentBalance += value.currentBalance;
      }
    });

    return getPercentChangeBetweenTwoNumbers(
      summedCostBasis,
      summedCurrentBalance,
    );
  },
  label: '% change',
  columnTypes: ['number'],
};
